import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
    selector: 'app-submission-packaging',
    templateUrl: './submission-packaging.component.html',
    styleUrls: ['./submission-packaging.component.scss'],
    standalone: false
})
export class SubmissionPackagingComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
   }

  ngOnInit() {

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      packageForm: this.fb.array([this.addPackageForm()])
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
  });
  }

  get packageForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('packageForm');
  }

  addPackageForm(): FormGroup {

    return this.fb.group({
      packageDI: ['', { validators: [] }],
      packageAgency: ['', { validators: [] }],
      containsPackageDI: ['', { validators: [] }],
      containsPackageAgency: ['', { validators: [] }],
      packageQty: ['', { validators: [] }],
      packageStatusValue: ['', { validators: [] }],
      packageType: ['', { validators: [] }]
    });
  }

  patchForms() {

    this.deviceForm.setControl('packageForm', this.setPackageForm());
  }

  setPackageForm(): FormArray {

    const formArray = new FormArray([]);

    let packages: any;

    packages = this.displayItemData('Packages');

    if (packages && packages.length > 0) {
      packages.forEach((c, i) => {

          formArray.push(

                this.fb.group({
                  packageDi: c[(this.getMapInnerPathName('Package DI'))[0]],
                  packageAgency: c[(this.getMapInnerPathName('Package DI Issuing Agency'))[0]],
                  packageQty: c[(this.getMapInnerPathName('Package Quantity'))[0]],
                    containingDI: c[(this.getMapInnerPathName('Contains Package DI'))[0]] ? c[(this.getMapInnerPathName('Contains Package DI'))[0]][(this.getMapInnerPathName('Contains Package DI'))[1]] : '',
                    containingAgency: c[(this.getMapInnerPathName('Contains Package DI'))[0]] ? c[(this.getMapInnerPathName('Contains Package DI Issuing Agency'))[0]][(this.getMapInnerPathName('Contains Package DI Issuing Agency'))[1]] : '',
                  packageStatusValue: c[(this.getMapInnerPathName('Package Status'))[0]] ? c[(this.getMapInnerPathName('Package Status'))[0]][(this.getMapInnerPathName('Package Status'))[1]] : '',
                    packageType: c[(this.getMapInnerPathName('Package Type'))[0]]
                })
            );
        });
    }

    return formArray;
  }
}

